// extracted by css-extract-rspack-plugin
var _1 = "vO_Snw7xP5YXH2mf";
export { _1 as "svgIconBase" }
// extracted by css-extract-rspack-plugin
var _1 = "vO_Snw7xP5YXH2mf";
export { _1 as "svgIconBase" }
